import React from 'react'
import PropTypes from 'prop-types'

import classes from 'classnames'

import { map, compact, isArray } from 'lodash'

const PanelHeading = ({ title, subtitle, withDivider, tools, children }) => (
    <div className={ classes('panel-heading', { 'panel-heading-divider': withDivider }) }>
        { title }
        { tools && (
            <div className="tools">
                { isArray(tools)
                    ? map(compact(tools), (tool, index) => (
                        React.cloneElement(tool, {
                            ...tool.props,
                            key: `tool-${index}`
                        })
                    ))
                    : tools
                }
            </div>
        ) }
        <span className="panel-subtitle">{ subtitle }</span>
        { children }
    </div>
)

PanelHeading.propTypes = {
    title       : PropTypes.node,
    subtitle    : PropTypes.node,
    withDivider : PropTypes.bool,
    tools       : PropTypes.node
}

PanelHeading.defaultProps = {
    withDivider: true
}

export default PanelHeading
